import { messageBus } from './MessageBus';
export function useMessageBus() {
  return messageBus;
}